import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { List } from 'immutable';
import SavedSearchItem from './SavedSearchItem';
import { getLocationByFilter } from '../../utils/urls';
import { DEFAULT_FILTER } from '../Search/filter';
import { getSavedSearchStatistic, getSavedSearchStatisticDealType } from '../../utils/section';
import { getUser } from '../User/actions';
import { updateFilter } from '../Search/actions';
import { getCianRedirectUrl } from '../Home/actions';
import {
  loadSavedSearch,
  deleteSavedSearch
} from './actions';
import connectDataFetchers from '../../lib/connectDataFetchers';
import {SALE, RENT, APARTMENTS} from '../../consts';
import SavedSearchDeleteModal from './SavedSearchDeleteModal';

class SavedSearch extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isDeleteModalOpen: false,
      deleteItemId: null,
      listLoaded: false
    };

    const statistic = props.user.getIn(['data', 'savedSearchStatistics'], new List()).toJS();
    const defaultRubric = getSavedSearchStatistic(statistic).filter(tab => tab[2]);
    this.dealType = props.match.params.dealType || (defaultRubric.length ? defaultRubric[0][3] : SALE);
    this.realtyType = props.match.params.realtyType || (defaultRubric.length ? defaultRubric[0][4] : APARTMENTS);

    this.defaultRentRubric = defaultRubric.length && defaultRubric.filter(item => item[3].includes('rent')).length
      ? defaultRubric.filter(item => item[3].includes('rent'))[0] : ['rentApartments', 'Аренда квартир, комнат', 0, RENT, APARTMENTS];
    this.defaultSaleRubric = defaultRubric.length && defaultRubric.filter(item => item[3].includes('sale')).length
      ? defaultRubric.filter(item => item[3].includes('sale'))[0] : ['saleApartments', 'Продажа квартир, комнат', 0, SALE, APARTMENTS];

    this.initSection(this.dealType, this.realtyType);

    this.goTo = this.goTo.bind(this);
    this.getTabs = this.getTabs.bind(this);
    this.getDealTypeTabs = this.getDealTypeTabs.bind(this);
    this.getTabsByDealType = this.getTabsByDealType.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.submitDeleteModal = this.submitDeleteModal.bind(this);
    this.openSavedSearch = this.openSavedSearch.bind(this);
    this.renderWelcome = this.renderWelcome.bind(this);
  }

  componentDidMount () {
    this.initSection(this.dealType, this.realtyType);
    if (this.props.user.getIn(['data', 'id'])) {
      this.props.loadSavedSearch().then(() =>
        this.setState({
          listLoaded: true
        })
      );
    }
  }

  initSection (dealType, realtyType) {
    this.dealType = dealType;
    this.realtyType = realtyType;
  }

  openDeleteModal (id) {
    this.setState({
      isDeleteModalOpen: true,
      deleteItemId: id
    });
  }

  closeDeleteModal () {
    this.setState({
      isDeleteModalOpen: false,
      deleteItemId: null
    });
  }

  submitDeleteModal () {
    this.props.deleteSavedSearch(this.state.deleteItemId);
    this.closeDeleteModal();
  }

  openSavedSearch (filter) {
    const { updateFilter, domain } = this.props;
    const realtyType = this.realtyType;
    const dealType = this.dealType;
    if (filter.page === undefined && filter.viewMode === undefined) {
      filter.page = 1;
    }
    const originalFilter = filter.merge(DEFAULT_FILTER);
    const regionId = originalFilter.get('regionId', null) || domain.get('regionId');
    const localityId = originalFilter.get('localityId', null) || domain.get('localityId', null);
    const token = this.props.user.get('token', null);
    const currentFilter = originalFilter
    .merge(filter)
    .set('regionId', regionId)
    .set('localityId', localityId)
    .set('token', token);

    updateFilter(currentFilter);
    const location = getLocationByFilter(currentFilter, dealType, realtyType);

    this.props.dispatch(push(location));
  }

  goTo (dealType, realtyType) {
    this.initSection(dealType, realtyType);

    this.props.dispatch(push(`/saved-searches/${dealType}/${realtyType}/`));
  }

  getTabsByDealType () {
    const statistic = this.props.user.getIn(['data', 'savedSearchStatistics'], new List()).toJS();
    const favoriteTabs = getSavedSearchStatistic(statistic, true);
    const currentDealType = this.dealType.includes('rent') ? 'rent' : 'sale';

    return favoriteTabs.filter(item => item[3].includes(currentDealType));
  }

  getTabs () {
    const statistic = this.props.user.getIn(['data', 'savedSearchStatistics'], new List()).toJS();

    return getSavedSearchStatistic(statistic, true);
  }

  getDealTypeTabs () {
    const statistic = this.props.user.getIn(['data', 'savedSearchStatistics'], new List()).toJS();

    return getSavedSearchStatisticDealType(statistic, false);
  }

  renderWelcome () {
    return (
      <div className='page-top-separator page-favorites page-favorites-welcome'>
        <div className='message-welcome'>
          Для сохранения поиска необходимо авторизоваться или зарегистрироваться.
          <br />
          Это позволит в любой момент и на любых Ваших устройствах вернуться к текущим результатам поиска.
        </div>
        <div className='register-btns'>
          <div className='controls'>
            <a href='/user/default/login/' className='btn btn-primary'>Войти</a>
            <a href='/user/default/registration/' className='btn btn-secondary'>Зарегистрироваться</a>
          </div>
        </div>
      </div>
    );
  }

  render () {
    const { savedSearchList, user, isLoading, domain } = this.props;
    const { isDeleteModalOpen, listLoaded } = this.state;

    const tabsByDealType = this.getTabsByDealType();
    const dealTypeTabs = this.getDealTypeTabs();

    if (!user.getIn(['data', 'id'])) {
      return this.renderWelcome();
    }

    return (
      <div className='page-top-separator saved-searches__wrp'>
        <div className='saved-searches__container'>
          <h2>Cохраненные поиски</h2>
          { isLoading &&
            (
              <div className='ajax-waiting-overlay'>
                <div className='radial-progress'>
                  <div className='circle'>
                    <div className='fill' />
                  </div>
                </div>
              </div>
            )
          }
          {savedSearchList.size !== 0 &&
            <div>
              <div className='deal-type-list btn-group-pills'>
                {dealTypeTabs.map((tab, index) => {
                  return <a
                    className={'btn btn-base' + (this.dealType.includes(tab[0]) ? ' pressed' : '')}
                    href={`/favorites/${tab[0] === 'sale'
                      ? this.defaultSaleRubric[3] : this.defaultRentRubric[3]}/${tab[0] === 'sale'
                      ? this.defaultSaleRubric[4] : this.defaultRentRubric[4]}`
                    }
                    key={index}
                    onClick={(e) => {
                      e.preventDefault();
                      this.goTo(tab[0] === 'sale'
                      ? this.defaultSaleRubric[3] : this.defaultRentRubric[3],
                      tab[0] === 'sale'
                      ? this.defaultSaleRubric[4] : this.defaultRentRubric[4]);
                    }}>
                    {tab[1]}
                    <div className={'bandage-count' + (this.dealType.includes(tab[0]) ? ' pressed' : '')}>
                      {tab[2]}
                    </div>
                  </a>;
                })}
              </div>
              {!!tabsByDealType.length &&
                <div className='rubric-list btn-group-pills'>
                  {tabsByDealType.map((tab, index) => {
                    return <a
                      className={'btn btn-base' + (tab[3] === this.dealType && tab[4] === this.realtyType ? ' pressed' : '')}
                      href={'/favorites/' + tab[3] + '/' + tab[4]}
                      key={index}
                      onClick={(e) => {
                        e.preventDefault();
                        this.goTo(tab[3], tab[4]);
                      }}>
                      {tab[1]}
                      <div className={'bandage-count' + (tab[3] === this.dealType && tab[4] === this.realtyType ? ' pressed' : '')}>
                        {tab[2]}
                      </div>
                    </a>;
                  })}
                </div>
              }
              <div className='saved-searches__list'>
                {savedSearchList.filter(i => i.get('realtyType') === this.realtyType && i.get('dealType') === this.dealType).map((i, index) => (
                  <SavedSearchItem
                    item={i}
                    openSavedSearch={this.openSavedSearch}
                    openDeleteModal={this.openDeleteModal}
                    key={`${this.dealType}_${this.realtyType}_${index}`}
                    user={user}
                    domain={domain}
                  />
                ))}
              </div>
            </div>
          }
          {savedSearchList.size === 0 && listLoaded &&
            <div className='saved-searches__empty-list'>
              <span className='saved-searches__empty-list_label'>Сохраненных поисков нет.</span>
              <span className='saved-searches__empty-list_description'>
                Сохраненные поиски позволяют в любой момент и на любых Ваших устройствах вернуться к текущим результатам поиска.
              </span>
            </div>
          }

        </div>
        <SavedSearchDeleteModal visible={isDeleteModalOpen} onSubmit={this.submitDeleteModal} onClose={this.closeDeleteModal} onReject={this.closeDeleteModal} />
      </div>
    );
  };
}

SavedSearch.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object
  }).isRequired,
  savedSearchList: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadSavedSearch: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  deleteSavedSearch: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
  domain: PropTypes.objectOf(PropTypes.any)
};

SavedSearch.defaultProps = {

};

function mapStateToProps (state) {
  return {
    savedSearchList: state.getIn(['savedSearch', 'items']),
    isLoading: state.getIn(['savedSearch', 'loading']),
    user: state.get('user'),
    domain: state.get('domain')
  };
}

function mapDispatchToProps (dispatch) {
  const actions = bindActionCreators({
    loadSavedSearch,
    deleteSavedSearch,
    updateFilter
  }, dispatch);

  actions.dispatch = dispatch;
  return actions;
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  connectDataFetchers(SavedSearch, [getUser, getCianRedirectUrl])
));



// WEBPACK FOOTER //
// ./src/app/SavedSearch/SavedSearch.jsx